import React from 'react';
import '../styles/MissionAchievementLiveFeed.css';
import { User } from '../../../types';

export interface MissionAchievementFeedItem {
  id: string;
  studentId: string;
  studentName: string;
  studentMuseImg?: string;
  achievementTitle: string;
  achievementIcon: string;
  museCashReward: number;
  rarity?: string;
  unlockedAt?: Date;
}

export default function MissionAchievementLiveFeed({
  items,
  studentsInAttendance,
}: {
  items: MissionAchievementFeedItem[];
  studentsInAttendance: User[];
}) {
  const visible = items.slice(0, 4);

  return (
    <div className="mission-achievement-feed-container" aria-label="Live achievements feed">
      <div className="mission-achievement-feed-header">
        <div className="mission-achievement-feed-title">Live Achievements</div>
      </div>

      <div className="mission-achievement-feed-list" role="list">
        {visible.length === 0 ? (
          <div className="mission-achievement-feed-empty">
            Waiting for achievements…
          </div>
        ) : (
          visible.map((item) => {
            return (
              <div key={item.id} className="mission-achievement-feed-item" role="listitem">
                <div className="mission-achievement-feed-left">
                  {item.studentMuseImg ? (
                    <img className="mission-achievement-feed-avatar" src={item.studentMuseImg} alt="" aria-hidden="true" />
                  ) : (
                    <div className="mission-achievement-feed-avatar-fallback" aria-hidden="true">
                      🎵
                    </div>
                  )}
                </div>

                <div className="mission-achievement-feed-body">
                  <div className="mission-achievement-feed-line" title={`${item.studentName} earned “${item.achievementTitle}”`}>
                    <span className="mission-achievement-feed-student">{item.studentName}</span>{' '}
                    <span className="mission-achievement-feed-earned">earned</span>{' '}
                    <span className="mission-achievement-feed-achievement">“{item.achievementTitle}”</span>
                  </div>
                </div>

                <div className="mission-achievement-feed-right" aria-hidden="true">
                  <div className="mission-achievement-feed-right-meta">
                    {item.museCashReward > 0 && (
                      <span className="mission-achievement-feed-cash" aria-label={`Worth ${item.museCashReward} muse cash`}>
                        +{item.museCashReward} 💰
                      </span>
                    )}
                  </div>
                </div>
              </div>
            );
          })
        )}
      </div>
    </div>
  );
}


